import type { FaireProductEntity } from "../../entity_types/product";

export const p_4yzdyctk4k: FaireProductEntity = {
  token: "p_4yzdyctk4k",
  type: "product",
  name: "TUMBLED STONES - CHALCEDONY, BLUE 15-35 MM (KG)",
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e1872c71918580555b6a90e6c77ebbeb3e61a7ca78053b20dd90cbda2eee41c0.jpeg",
  galleryImageUrls: [],
  priceDollars: 192.47,
  description:
    "Discover the spiritual tranquility with our Tumbled Stones - Chalcedony, Blue 15-35 mm (lb). Brought to you by Oceanic Linkways Inc, a premier wholesaler renowned for high-quality gemstones, jewelry, and spiritual gifts since 1991. Our blue Chalcedony stones are meticulously sourced from 19 countries and are perfect for creating a peaceful and serene environment. Ideal for home decor or as a spiritual gift, these stones embody our commitment to quality and authenticity. Enhance your spiritual journey with our beautiful tumbled stones today.",
  tags: [],
  msrpDollars: 384.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:28.418Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
